import React, { Fragment, useState, useEffect, useRef } from "react";
import { Redirect } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import Button from "@mui/material/Button";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import { Link, Navigate, useNavigate } from "react-router-dom";
import Lottie from "lottie-react";
import loading from "../components/loading.json";
import { themeStyle, themeStyleDark } from "../components/Components";
import { gsap } from "gsap";
import Backdrop from "@mui/material/Backdrop";
import bg from "../bg.mp4";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ArrowUpwardIcon from "@mui/icons-material/ArrowUpward";
import { Grid } from "@mui/material";
import XIcon from "@mui/icons-material/X";
import InstagramIcon from "@mui/icons-material/Instagram";
import FacebookIcon from "@mui/icons-material/Facebook";
import EmailIcon from "@mui/icons-material/Email";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import LocalPhoneIcon from "@mui/icons-material/LocalPhone";
import VisitUs from "../components/VisitUs";

export default function AboutChairman() {
  const state = useSelector((state) => state);

  useEffect(() => {}, []);

  function getContent() {
    return (
      <div className="main">
        <Sidebar />
        <div className="overlay"></div>

        <div
          className="abouthero"
          style={{
            background:
              "linear-gradient(0deg, rgba(2, 77, 194, 0.2), rgba(2, 77, 194, 0.2)), url('" +
              require("../img/asmb.jpg") +
              "')",
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <div
            style={{
              fontSize: state.auth.isMobile ? "30px" : "30px",
              fontWeight: "bold",
              fontFamily: "Montserrat",
              color:
                state.auth.theme == "dark"
                  ? themeStyleDark.primaryButtonTextColor
                  : themeStyle.primaryButtonTextColor,
            }}
          >
            Chairman's Message
          </div>
        </div>

        <div className="aboutabout" style={{ marginTop: "50px" }}>
          <Grid container spacing={5}>
            <Grid item xs={12} md={5}>
              <img
                style={{ width: "100%", objectFit: "cover", margin: "10px" }}
                src={require("../img/chair.png")}
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={7} xl={7}>
              <div
                style={{
                  fontSize: "32px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                  color:
                    state.auth.theme == "dark"
                      ? themeStyleDark.primaryColor
                      : themeStyle.primaryColor,
                  fontWeight: "bold",
                }}
              >
                Chairman's Message
              </div>
              <br />
              <div
                style={{
                  fontSize: state.auth.isMobile ? "18px" : "22px",
                  fontFamily: "Montserrat",
                  textAlign: "justify",
                }}
              >
                <b>
                  {" "}
                  "We cannot always build the future for our youth, but we can
                  build our youth for the future."{" "}
                </b>{" "}
                - Franklin D. Roosevelt <br />
                <br /> It gives me an immense pleasure to welcome you to the
                family of SLV group of Institutions. The above words by Franklin
                D. Roosevelt perfectly describe our aim. Our aim is to teach
                students to LEARN, not just STUDY. Hence, we strive to travel
                beyond the boundaries of mere books. We have realized that the
                future is abstract and unknown but the youth In our hands are
                real and can be moulded. Our philosophy of education has always
                been meeting the needs of the individual child. Children acquire
                skills and knowledge easily if we make the surrounding
                stimulating and purposeful. Education is a complete process that
                leads to the attainment of the full potential of the child. It
                makes a child a right thinker and a good decision-maker.
                <br />
                <br />
                Our focus is to develop our students as global citizens, with
                tolerance, respect, and appreciation of diverse cultures and
                religions for a lifetime learning experience. They should be
                self-motivated, independent, confident decision makers to take
                up leadership roles in the future. At our school, we provide an
                environment and curriculum where children can explore and
                develop every aspect of their lives. In other words, this unique
                educational institution seeks to blend the beauty of traditional
                cultural values and the latest in teaching aids and methodology
                to optimize learning, open young minds and empower young people
                to become global citizens, who stand tall and live with courage
                and conviction, carving a niche for themselves wherever they
                go.We opine that an ideal school system should be characterized
                by flexibility which makes it adaptable to changes. It should be
                a place....
                <br /> <br /> - Where Learning is an integrated activity and
                encourages children to link it with their everyday lives in some
                way. <br />- Which promote thoughts that encourage creative
                thinking. e Where learning builds capacity to create new
                knowledge. <br />
                - Where the "future" of the child should never take centre stage
                against the child's "present".
                <br />
                <br /> I welcome you to SLV International School with best
                wishes & good luck.
                <br /> <br />
                <b> Mr. Gopala Gowda M.</b> <br /> Founder Chairman
              </div>
            </Grid>
          </Grid>
        </div>

        <VisitUs />
        <Footer />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "100%",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor:
          state.auth.theme == "dark"
            ? themeStyleDark.backgroundColor
            : themeStyle.backgroundColor,
        transition: "opacity 2s",
      }}
    >
      {getContent()}
    </div>
  );
}
